import './styles/main.css';
import { bootstrap } from './app/bootstrap';

const container = document.getElementById('app');
if (!container) {
  throw new Error('STARFALL: missing #app container in index.html');
}

void bootstrap(container);
